<template>
    <div class="edit-group-modal">
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-position="top"
            label-width="100px"
        >
            <el-form-item
                v-if="!edit"
                :label="getVerbose('group_modal_form_label_name')"
                prop="name"
            >
                <el-input v-model="form.name" :placeholder="getVerbose('group_modal_form_name_placeholder')"></el-input>
            </el-form-item>
            <el-form-item
                :label="getVerbose('group_modal_form_label_members')"
                prop="members_uid"
            >
                <el-transfer
                    v-model="form.members_uid"
                    :data="usersFormated"
                    :titles="[getVerbose('group_modal_form_transfer_from'), getVerbose('group_modal_form_transfer_to')]"
                    :filter-placeholder="getVerbose('group_modal_form_transfer_placeholder')"
                    class="transfert-sized"
                    filterable
                >
                </el-transfer>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import schwartz from 'schwartz';

export default {
    props: {
        users: {
            type: Array,
            required: true,
        },
        group: {
            type: Object,
            default (){
                return null;
            },
        },
        existingGroups: {
            type: Array,
            required: true,
        },
        edit: {
            type: Boolean,
            default: false,
        },
        getVerbose: {
            type: Function,
            required: true
        },
        groupCreationAdditionnalValidators: {
            type: Array,
            required: false,
            default: () => { return []; }
        }
    },

    data (){
        let checkName = (rule, value, callback) => {
            if (!value) {
                return callback(new Error(this.getVerbose('group_modal_form_error_name_empty')));
            }
            let regex = /[a-zA-Z0-9-]+/g;
            let match = value.match(regex);
            if(match === null || match.length > 1){
                return callback(new Error(this.getVerbose('group_modal_form_error_syntax')));
            }

            if(!this.edit && this.existingGroups.find((g) => g.name.toUpperCase() === value.toUpperCase())){
                return callback(new Error(this.getVerbose('group_modal_form_error_name_taken')));
            }
            let validators = this.groupCreationAdditionnalValidators;
            for(let validator of validators){
                try{
                    validator(value);
                }
                catch(e){
                    // e should be the message thrown as an error in the validator
                    callback(e);
                }
            }
            callback();
        };
        return {
            form: {
                name: '',
                members_uid: [],
            },
            rules: {
                name: [{validator: checkName, trigger: 'change'}],
            },
        };
    },

    computed: {
        usersFormated (){
            return schwartz(this.users.map((user) => {
                return {
                    label: user.verbose_name,
                    key: user.uid,
                };
            }), (user) => {
                return user.label;
            });
        }
    },

    mounted (){
        if(this.group !== null){
            this.$set(this, 'form', this.group);
        }
    },

    methods: {
    },
};
</script>

<style lang="scss">

.el-message-box {
    width: 80%;
}
.edit-group-modal{
    .el-form-item {
        margin-bottom: 10px;
    }
    .el-form-item__label {
        padding: 0;
    }
    .transfert-sized{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .el-transfer-panel{
            width: 100%;
            @media (min-width: 500px) {
                width: 40%;
            }
            .el-transfer-panel__body {
                height: 180px;
                @media (min-width: 500px) {
                    height: 250px;
                }
            }
        }
        .el-transfer__buttons{
            display: flex;
            width: 100%;
            @media (min-width: 500px) {
                display: inherit;
                width: 20%;
            }
            button{
                margin: 10px auto;
                transform: rotate(90deg);
                @media (min-width: 500px) {
                    transform: unset;
                    vertical-align: middle;
                    margin: auto;
                    margin-bottom: 10px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/usersManagement/group/create-edit-group-modal.vue